// extracted by mini-css-extract-plugin
export default {"indicatorContainer":"LoadingIndicator_indicatorContainer__YyAZr","loader":"LoadingIndicator_loader__PuAmw"};